import React from 'react'
import TableGeneric from '../../compartidos/abms/TableGeneric'
import { Typography } from '@material-ui/core'

export const TablaHistorialExpedientes = ({trackingExpedientes, componentRef, optionsfecha}) => {
  return (
    <>
    {Array.isArray(trackingExpedientes) && trackingExpedientes.length > 0 ? (
      <TableGeneric
        ref={componentRef}
        data={trackingExpedientes}
        sizeTableCells={["15%", "12%", "15%", "15%", "15%", "30%"]}
        columns={[
          {
            label: "Fecha",
            id: "fecha",
            sort: true,
            customBody: (item) => `${
              new Date(item.fecha).toLocaleString(
              "es",
              optionsfecha
            )}`
          },
          {
            label: "Usuario",
            id: "usuario",
            customBody: (item) => `${item.usuario.userName}`
          },
          {
            label: "Campo",
            id: "campo",
            customBody: (item) => `${item.campo}`
          },
          {
            label: "Valor Anterior",
            id: "valorAnterior",
            sort: true,
            customBody: (item) => (
              <Typography style={{ color: "red", fontWeight: "bold" }}>
                {item.valorAnterior}
              </Typography>
            )
          },
          {
            label: "Valor Nuevo",
            id: "valorNuevo",
            sort: true,
            customBody: (item) => (
              <Typography style={{ color: item.valorNuevo.includes('Eliminad') ? "red" : "green", fontWeight: "bold" }}>
                {item.valorNuevo}
              </Typography>
            )
          },
          // {
          //   label: "Observación",
          //   id: "observacion",
          //   customBody: (item) => `${item.observacion ?? ''}`
          // }
        ]}
      />
    ) : (
      <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
        No hay datos
      </Typography>
    )}
</>
  )
}
